import {Moment} from 'moment';
import {ICustomer} from './customer.model';
import {ITransaction} from "./transaction.model";
import {IProjectItems} from "./project-items.model";
import {ISalesCycle} from "./salesCycle.model";

export interface IProject {
  id?: number;
  isdeleted?: boolean;
  title?: string;
  // startDate?: Moment;
  customer?: ICustomer;
  itemName?: string;
  code?: string;
  address?: string;
  audience?: string;
  phone?: any;
  step_number?: any;
  status?: string;
  level?: string;
  close_status?: string;
  step?: string;
  project_step?: string;
  floor_number?: string;
  number_of_units?: string;
  order_usage?: string;
  total_area?: string;
  construction_stage?: string;
  updateDate?: string;
  description?: string;
  salesCycle_str?: any;
  lastModifiedDate?: any;
  last_modified_date?: any;
  createdDate?: any;
  created_date?: any;
  startDate?: any;
  endDate?: any;
  endDateReal?: any;
  percentProgress?: any;
  start?: string;
  end?: string;
  endReal?: string;
  createdBy?: string;
  lastModifiedBy?: string;
  closed?: boolean;
  discount?: number;
  discountDescription?: string;
  transactions?: ITransaction[];
  projectItems?: IProjectItems[];
  salesCycle?: ISalesCycle;

}

export class Project implements IProject {

  constructor(public id?: number,
              public title?: string,
              public address?: string,
              public step?: string,
              public project_step?: string,
              public description?: string,
              public startDate?: any,
              public endDate?: any,
              public customer?: ICustomer,
              public createdBy?: string,
              public lastModifiedBy?: string,
              public closed?: boolean,
              public lastModifiedDate?: any,
              public created_date?: any,
              public last_modified_date?: any,
              public step_number?: any,
              public transactions?: ITransaction[],
              public createdDate?: any) {
  }
}
